module.exports = __webpack_public_path__ + "img/08_face.4cc6fcd5.png";